<template>
  <ul :class="['chat', { '--riddle': riddle }]" ref="chat">
    <component
      :is="getComponent(message.flexLayout)"
      :first="compareMessages(message.flexLayout, index, true)"
      :last="compareMessages(message.flexLayout, index)"
      :content="message"
      v-for="(message, index) in renderedMessages"
      :key="message.flexKey"
    />
    <Transition name="fade">
      <ChatAvatar v-if="renderedMessages.length" :offset-top="agentOffset" scroll />
    </Transition>
  </ul>
</template>

<script>
import { ChatHunterLink, ChatImage, ChatMessage } from '@/components/chat'
import ChatAvatar from '@/components/chat/ChatAvatar.vue'

export default {
  name: 'Chat',
  components: { ChatAvatar },
  props: {
    messages: {
      type: Array,
      required: true,
    },
    renderCacheKey: {
      type: String,
      required: true,
    },
    riddle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      agentOffset: 0,
      interval: null,
      renderedMessages: [],
    }
  },
  mounted() {
    if (this.$store.state.cache.chats.includes(this.renderCacheKey)) {
      this.renderedMessages = this.messages
      this.$nextTick(() => this.updateAgentOffset())
      this.$emit('rendered')
    } else this.interval = setInterval(this.renderMessage, 1000)
  },
  methods: {
    compareMessages(layoutKey, index, previous = false) {
      if ((previous && index === 0) || (!previous && index === this.messages.length - 1)) {
        return true
      }

      const compareOffset = previous ? -1 : 1

      const nextMsgType = this.getMessageType(this.messages[index + compareOffset].flexLayout)
      const msgType = this.getMessageType(layoutKey)

      return nextMsgType !== msgType
    },
    getComponent(layoutKey) {
      switch (layoutKey) {
        case 'chat-hunter-link-repeatable':
          return ChatHunterLink
        case 'chat-image-repeatable':
          return ChatImage
        case 'chat-message-repeatable':
          return ChatMessage
        default:
          return ''
      }
    },
    getMessageType(layoutKey) {
      switch (layoutKey) {
        case 'chat-image-repeatable':
        case 'chat-message-repeatable':
          return 'agent'
        default:
          return 'hunter'
      }
    },
    async renderMessage() {
      if (this.renderedMessages.length < this.messages.length) {
        this.renderedMessages.push(this.messages[this.renderedMessages.length])

        setTimeout(this.updateAgentOffset, 20)
      } else {
        await clearInterval(this.interval)
        await this.$store.dispatch('updateChatsCache', this.renderCacheKey)
        this.$emit('rendered')
      }
    },
    updateAgentOffset() {
      window.scrollTo({ behavior: 'smooth', top: document.body.scrollHeight })
      const agentMessages = this?.$refs?.chat?.querySelectorAll(
        '.chat__image.--agent, .chat__message.--agent',
      )
      if (agentMessages) {
        const targetMessage = agentMessages[agentMessages.length - 1]
        const hunterOffset =
          this.renderedMessages[this.renderedMessages.length - 1].flexLayout ===
          'chat-hunter-link-repeatable'
            ? 16
            : 0
        this.agentOffset = targetMessage.offsetTop + targetMessage.offsetHeight - 30 - hunterOffset
      }
    },
  },
  emits: ['rendered'],
}
</script>
